/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputWindLabSegment
 */
export interface OutputWindLabSegment {
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabSegment
     */
    airspeedMs?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabSegment
     */
    courseDeg?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabSegment
     */
    groundSpeedMs?: number;
    /**
     * чи були дані вітру на сегменті
     * @type {boolean}
     * @memberof OutputWindLabSegment
     */
    hasWind?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabSegment
     */
    index?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabSegment
     */
    lenM?: number;
    /**
     * де семпиться/малюється вітор сегмента
     * @type {number}
     * @memberof OutputWindLabSegment
     */
    midLat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabSegment
     */
    midLng?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabSegment
     */
    secondsNoWind?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputWindLabSegment
     */
    secondsWind?: number;
    /**
     * модуль вітру
     * @type {number}
     * @memberof OutputWindLabSegment
     */
    windSpeedMs?: number;
    /**
     * східна складова (куди дме)
     * @type {number}
     * @memberof OutputWindLabSegment
     */
    windUMs?: number;
    /**
     * північна складова
     * @type {number}
     * @memberof OutputWindLabSegment
     */
    windVMs?: number;
}

/**
 * Check if a given object implements the OutputWindLabSegment interface.
 */
export function instanceOfOutputWindLabSegment(value: object): boolean {
    return true;
}

export function OutputWindLabSegmentFromJSON(json: any): OutputWindLabSegment {
    return OutputWindLabSegmentFromJSONTyped(json, false);
}

export function OutputWindLabSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputWindLabSegment {
    if (json == null) {
        return json;
    }
    return {
        
        'airspeedMs': json['airspeedMs'] == null ? undefined : json['airspeedMs'],
        'courseDeg': json['courseDeg'] == null ? undefined : json['courseDeg'],
        'groundSpeedMs': json['groundSpeedMs'] == null ? undefined : json['groundSpeedMs'],
        'hasWind': json['hasWind'] == null ? undefined : json['hasWind'],
        'index': json['index'] == null ? undefined : json['index'],
        'lenM': json['lenM'] == null ? undefined : json['lenM'],
        'midLat': json['midLat'] == null ? undefined : json['midLat'],
        'midLng': json['midLng'] == null ? undefined : json['midLng'],
        'secondsNoWind': json['secondsNoWind'] == null ? undefined : json['secondsNoWind'],
        'secondsWind': json['secondsWind'] == null ? undefined : json['secondsWind'],
        'windSpeedMs': json['windSpeedMs'] == null ? undefined : json['windSpeedMs'],
        'windUMs': json['windUMs'] == null ? undefined : json['windUMs'],
        'windVMs': json['windVMs'] == null ? undefined : json['windVMs'],
    };
}

export function OutputWindLabSegmentToJSON(value?: OutputWindLabSegment | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'airspeedMs': value['airspeedMs'],
        'courseDeg': value['courseDeg'],
        'groundSpeedMs': value['groundSpeedMs'],
        'hasWind': value['hasWind'],
        'index': value['index'],
        'lenM': value['lenM'],
        'midLat': value['midLat'],
        'midLng': value['midLng'],
        'secondsNoWind': value['secondsNoWind'],
        'secondsWind': value['secondsWind'],
        'windSpeedMs': value['windSpeedMs'],
        'windUMs': value['windUMs'],
        'windVMs': value['windVMs'],
    };
}

